export namespace EntitlementsExtras {
	export const plan_basic = "plan_basic_5"
	export const plan_advanced = "plan_advanced_10"
	// Check
	export const plan_tire_1_monthly =
		"token_subs_monthly_pack_tire_1"
	export const plan_tire_1_yearly =
		"token_subs_yearly_pack_tire_1"
	export const plan_tire_2_monthly =
		"token_subs_monthly_pack_tire_3"
	export const plan_tire_2_yearly =
		"token_subs_yearly_pack_tire_3"
	export const plan_tire_3_monthly =
		"token_subs_monthly_pack_tire_2"
	export const plan_tire_3_yearly =
		"token_subs_yearly_pack_tire_2"
	export const advanced_organization =
		"advanced_organization"
	export const promo_code_durations = [
		"daily",
		"three_day",
		"weekly",
		"monthly",
		"two_month",
		"three_month",
		"six_month",
		"yearly",
		"lifetime",
	] as const

	export function getTireFromString(
		str: string,
	): "free" | "tire_1" | "tire_2" | "tire_3" | null {
		const regex = /tire_(\d+)/
		const match = str.match(regex)
		const tire = match ? `tire_${match[1]}` : null
		if (
			tire == "tire_1" ||
			tire == "tire_2" ||
			tire == "tire_3"
		) {
			return tire
		}
		return null
	}
}
